export const categories = [
  {
    id: 'dianying',
    name: '电影',
    slug: 'dianying',
    icon: 'ri-movie-2-line',
    description: '最新正版电影资源，涵盖动作、喜剧、科幻、剧情等多种类型，高清画质畅享观影体验',
    articleCount: 256,
  },
  {
    id: 'dianshiju',
    name: '电视剧',
    slug: 'dianshiju',
    icon: 'ri-tv-2-line',
    description: '热门电视剧全集收录，国产剧、海外剧、网剧一网打尽，每日同步更新',
    articleCount: 389,
  },
  {
    id: 'zongyi',
    name: '综艺',
    slug: 'zongyi',
    icon: 'ri-emotion-laugh-line',
    description: '热门综艺节目高清资源，搞笑、音乐、竞技、真人秀类型齐全',
    articleCount: 178,
  },
  {
    id: 'dongman',
    name: '动漫',
    slug: 'dongman',
    icon: 'ri-ghost-line',
    description: '日本动漫、国产动画、欧美动画全覆盖，经典番剧与新番同步放送',
    articleCount: 312,
  },
  {
    id: 'jilu',
    name: '纪录片',
    slug: 'jilu',
    icon: 'ri-landscape-line',
    description: 'BBC、Discovery、NHK等顶级纪录片资源，探索自然、历史、科技与人文',
    articleCount: 145,
  },
  {
    id: 'tiyu',
    name: '体育',
    slug: 'tiyu',
    icon: 'ri-basketball-line',
    description: '精彩体育赛事直播与回放，足球、篮球、网球等热门运动全覆盖',
    articleCount: 98,
  },
  {
    id: 'yinyue',
    name: '音乐',
    slug: 'yinyue',
    icon: 'ri-music-2-line',
    description: 'MV、演唱会、音乐节目高清资源，流行、古典、摇滚等多种风格',
    articleCount: 203,
  },
  {
    id: 'youxi',
    name: '游戏',
    slug: 'youxi',
    icon: 'ri-gamepad-line',
    description: '热门游戏攻略、实况解说、电竞赛事回放，游戏玩家的专属频道',
    articleCount: 167,
  },
];

export const articles = [
  {
    id: '1',
    title: '《星际穿越》4K重制版独家上线：诺兰科幻神作再临，视觉盛宴震撼回归',
    slug: 'interstellar-4k-remastered',
    categoryId: 'dianying',
    excerpt: '克里斯托弗·诺兰执导的科幻经典《星际穿越》4K重制版正式登陆91天堂平台。这部曾获得奥斯卡最佳视觉效果奖的影片以全新画质回归，带领观众再次穿越虫洞，探索人类存亡的终极命题。',
    content: `《星际穿越》是克里斯托弗·诺兰于2014年执导的科幻巨制，由马修·麦康纳、安妮·海瑟薇、杰西卡·查斯坦等实力派演员主演。影片讲述了在不远的未来，地球面临严重的环境危机，前NASA飞行员库珀被选中加入一项穿越虫洞的太空任务，为人类寻找新的家园。

    此次4K重制版采用了最新的HDR技术，画面细腻度提升显著。在宇宙场景中，暗部细节更加丰富，星际穿越的视觉冲击力达到了前所未有的高度。汉斯·季默的配乐经过重新混音，在杜比全景声的加持下，管风琴的震撼音效直击心灵。

    影片中的科学顾问团队由诺贝尔物理学奖得主基普·索恩领衔，确保了影片中黑洞、虫洞等高深物理概念的科学准确性。此次重制版还附带了全新的幕后花絮内容，包括未曾公开的拍摄现场记录和科学顾问的深度访谈。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Interstellar%20movie%20poster%20style%2C%20astronaut%20floating%20near%20black%20hole%2C%20cosmic%20dust%20and%20stars%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20film%20grain%20texture%2C%20warm%20golden%20and%20deep%20black%20contrast%2C%20artistic%20minimal%20design&width=800&height=450&seq=movie-interstellar&orientation=landscape',
    author: '编辑部',
    publishDate: '2026-08-05',
    viewCount: 12890,
    tags: ['科幻', '诺兰', '4K重制', '经典回顾'],
  },
  {
    id: '2',
    title: '《庆余年》第三季独家预告解析：范闲身世之谜即将揭晓，权谋升级',
    slug: 'qingyunian-season3-preview',
    categoryId: 'dianshiju',
    excerpt: '备受期待的《庆余年》第三季官方预告片在91天堂平台独家首发。预告片中范闲面对全新挑战，朝堂权谋与江湖恩怨交织升级，众多角色命运引发观众热议。',
    content: `《庆余年》第三季延续了前两季的精彩叙事，改编自猫腻同名小说。本季将揭开范闲身世之谜的核心篇章，同时朝堂权谋的复杂性也达到了前所未有的高度。

    从预告片可以看出，本季制作规模全面升级。战争场面采用实景与CG结合的方式拍摄，千军万马的气势磅礴令人震撼。陈道明饰演的庆帝与张若昀饰演的范闲之间的对手戏更是看点十足。

    据悉，第三季共45集，将在91天堂平台同步更新。制作团队表示，本季将呈现全书最精彩的「大东山」篇章，范闲的身世真相、叶轻眉的过往以及监察院的终极使命都将在本季水落石出。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%2C%20ancient%20palace%20interior%20with%20warm%20candlelight%2C%20martial%20arts%20costume%2C%20atmospheric%20mist%2C%20dramatic%20shadow%20play%2C%20rich%20red%20and%20gold%20tones%2C%20cinematic%20portrait%20style%2C%20minimal%20clean%20composition&width=800&height=450&seq=drama-qingyunian&orientation=landscape',
    author: '编辑部',
    publishDate: '2026-08-04',
    viewCount: 25670,
    tags: ['古装', '权谋', '热门剧集', '独家'],
  },
  {
    id: '3',
    title: '《向往的生活》第九季收官特辑：黄磊何炅深情告别蘑菇屋，感动全场',
    slug: 'xiangwangdeshenghuo-season9-finale',
    categoryId: 'zongyi',
    excerpt: '陪伴观众多年的慢综艺《向往的生活》第九季在91天堂平台迎来收官。黄磊与何炅在蘑菇屋的最后一夜，回顾九季以来的温暖瞬间，引发观众集体回忆。',
    content: `《向往的生活》自开播以来，以其独特的慢生活理念和真挚的情感交流赢得了无数观众的喜爱。第九季作为收官季，嘉宾阵容更加豪华，而节目的内核始终未变——回归生活的本真。

    在收官特辑中，黄磊和何炅再次回到最初的蘑菇屋，回忆起九年来在这里度过的每一个日夜。从第一季的简陋小屋到如今成为观众心中的精神家园，蘑菇屋见证了太多温暖故事。

    何炅在节目中动情表示：「九年的时光，感谢每一位观众的陪伴。向往的生活不是去远方，而是珍惜眼前的每一个人、每一顿饭、每一个日出日落。」节目最后，所有曾来过蘑菇屋的嘉宾通过视频送上祝福，场面温馨感人。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20countryside%20cottage%20with%20warm%20evening%20light%2C%20simple%20wooden%20table%20with%20homecooked%20meal%2C%20green%20garden%20surroundings%2C%20soft%20golden%20hour%20glow%2C%20peaceful%20rural%20atmosphere%2C%20minimal%20clean%20aesthetic&width=800&height=450&seq=variety-life&orientation=landscape',
    author: '编辑部',
    publishDate: '2026-08-03',
    viewCount: 18920,
    tags: ['综艺', '慢生活', '收官', '感动'],
  },
  {
    id: '4',
    title: '《进击的巨人》最终季剧场版确认引进：艾伦终极抉择，史诗终章来袭',
    slug: 'attack-on-titan-final-movie',
    categoryId: 'dongman',
    excerpt: '谏山创原作的超人气动漫《进击的巨人》最终季剧场版正式确认引进91天堂平台。影片将呈现漫画结尾的完整故事线，艾伦·耶格尔的最终命运即将揭晓。',
    content: `《进击的巨人》作为近十年来最具影响力的动漫作品之一，其最终季剧场版备受全球粉丝期待。此次剧场版由MAPPA工作室倾力打造，画质与动作场面全面升级。

    剧场版将聚焦艾伦发动「地鸣」之后的终极决战。调查兵团的幸存者们将面对曾经并肩作战的同伴，在拯救世界与守护友情之间做出艰难抉择。三笠、阿尔敏与艾伦之间的羁绊将在终章中迎来最终答案。

    91天堂平台将提供日语原声与中文配音双版本，并附赠制作特辑与声优访谈。上线首周还将举办线上观影活动，邀请粉丝一起见证这部史诗作品的最终篇章。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20art%20style%2C%20epic%20fantasy%20battle%20scene%2C%20titan%20silhouette%20against%20crimson%20sky%2C%20dramatic%20lighting%20with%20god%20rays%2C%20soldiers%20with%20swords%2C%20atmospheric%20dust%20and%20debris%2C%20cinematic%20composition%2C%20dark%20and%20moody%20tone&width=800&height=450&seq=anime-aot&orientation=landscape',
    author: '编辑部',
    publishDate: '2026-08-02',
    viewCount: 34210,
    tags: ['动漫', '热血', '剧场版', '谏山创'],
  },
  {
    id: '5',
    title: 'BBC纪录片《地球脉动III》4K完整版：六年磨一剑，探索地球上最后的荒野',
    slug: 'planet-earth-iii-4k',
    categoryId: 'jilu',
    excerpt: '大卫·爱登堡爵士倾情解说的BBC自然纪录片巅峰之作《地球脉动》第三季在91天堂平台上线4K完整版。制作团队历时六年，走遍全球43个国家，记录下自然界最震撼的瞬间。',
    content: `《地球脉动III》是有史以来制作规模最大的自然纪录片之一。BBC自然历史部的拍摄团队采用了最先进的8K摄影机和无人机技术，深入地球上最偏远的角落，捕捉到了许多此前从未被镜头记录的珍稀画面。

    本季共8集，涵盖海洋、沙漠、丛林、草原、极地、山脉、淡水与城市生态等多个主题。每一帧画面都堪称艺术级别的摄影作品，配合汉斯·季默工作室的全新配乐，带来视听双重震撼。

    特别值得一提的是「城市生态」这一集，首次系统性地展现了野生动物如何在人类城市中生存和适应。从纽约的高楼大厦间的游隼到孟买街头的花豹，这些画面令人深思人与自然的关系。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Breathtaking%20nature%20documentary%20scene%2C%20mountain%20gorilla%20in%20misty%20rainforest%2C%20soft%20diffused%20morning%20light%20through%20canopy%2C%20rich%20green%20foliage%2C%20atmospheric%20fog%2C%20cinematic%20wildlife%20photography%2C%20minimal%20clean%20composition&width=800&height=450&seq=doc-planet&orientation=landscape',
    author: '编辑部',
    publishDate: '2026-08-01',
    viewCount: 15870,
    tags: ['纪录片', 'BBC', '自然', '4K'],
  },
  {
    id: '6',
    title: '2026世界杯亚洲区预选赛全程回放：中国男足关键战役全收录',
    slug: 'world-cup-2026-asian-qualifiers',
    categoryId: 'tiyu',
    excerpt: '2026年世界杯亚洲区预选赛精彩赛事全程回放已在91天堂平台上线。中国队关键战役全收录，多机位高清画质还原每一个精彩瞬间。',
    content: `2026年美加墨世界杯亚洲区预选赛已经进入白热化阶段。91天堂平台作为官方授权转播平台，为球迷提供全部场次的高清回放服务。

    中国队在本届预选赛中的表现令人振奋。面对亚洲强队的挑战，球队展现出顽强的斗志和日益成熟的战术体系。平台特别制作了中国队专题合集，收录了所有比赛的多角度回放、战术分析以及赛后访谈。

    除了中国队比赛外，平台还提供日本、韩国、伊朗等亚洲劲旅的全部赛事回放，以及欧洲、南美赛区的精选比赛。资深解说员的专业评述与多视角慢动作回放，让球迷不错过任何精彩细节。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20at%20night%2C%20floodlights%20illuminating%20green%20pitch%2C%20players%20in%20red%20jersey%20celebrating%20goal%2C%20dramatic%20stadium%20atmosphere%2C%20crowd%20silhouettes%2C%20sports%20photography%20style%2C%20clean%20dynamic%20composition&width=800&height=450&seq=sports-soccer&orientation=landscape',
    author: '编辑部',
    publishDate: '2026-07-31',
    viewCount: 45230,
    tags: ['体育', '足球', '世界杯', '中国队'],
  },
  {
    id: '7',
    title: '周杰伦2026世界巡回演唱会上海站独家4K全场：经典金曲万人合唱',
    slug: 'jay-chou-2026-shanghai-concert',
    categoryId: 'yinyue',
    excerpt: '华语乐坛天王周杰伦2026世界巡回演唱会上海站4K全场视频在91天堂平台独家上线。近三小时的视听盛宴，经典金曲引发全场万人合唱。',
    content: `周杰伦2026「嘉年华」世界巡回演唱会上海站在梅赛德斯-奔驰文化中心连开三场，场场爆满。91天堂平台获得独家线上播映权，为无法到场的歌迷提供4K高清全场回放。

    演唱会以「半兽人」震撼开场，炫目的视觉特效与周杰伦标志性的音乐风格完美融合。整场演出涵盖了他出道二十余年来的经典作品，从「晴天」、「七里香」到「告白气球」、「等你下课」，每一首都能引发全场大合唱。

    值得一提的是，本次演唱会还特别加入了互动环节——周杰伦随机挑选现场观众点歌，并用钢琴即兴伴奏。这个环节诞生了许多令人惊喜的音乐瞬间，被歌迷称为「最值得珍藏的演唱会版本」。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20dazzling%20light%20show%2C%20purple%20and%20gold%20stage%20lighting%2C%20massive%20LED%20screen%20background%2C%20silhouette%20of%20performer%2C%20thousands%20of%20light%20sticks%20in%20audience%2C%20epic%20concert%20atmosphere%2C%20dramatic%20wide%20angle%20composition&width=800&height=450&seq=music-concert&orientation=landscape',
    author: '编辑部',
    publishDate: '2026-07-30',
    viewCount: 67890,
    tags: ['音乐', '周杰伦', '演唱会', '独家'],
  },
  {
    id: '8',
    title: '《黑神话：悟空》DLC正式发售：全新章节「狮驼岭」深度评测',
    slug: 'black-myth-wukong-dlc-review',
    categoryId: 'youxi',
    excerpt: '国产3A大作《黑神话：悟空》首个大型DLC「狮驼岭」正式发售。91天堂游戏频道第一时间带来深度评测与完整攻略视频，带你征服这个最黑暗的章节。',
    content: `游戏科学工作室推出的《黑神话：悟空》DLC「狮驼岭」终于与玩家见面。这个全新章节基于《西游记》中最黑暗的篇章改编，讲述了孙悟空途经狮驼岭时遭遇三大魔王——青毛狮子、黄牙老象与大鹏金翅雕的故事。

    DLC新增了超过15小时的游戏内容，包含三个全新的Boss战，每一个都经过精心设计，战斗体验各有特色。其中与大鹏金翅雕的最终对决被认为是本作最精彩的Boss战之一——战斗分为多个阶段，场景从地上打到云端，视觉冲击力极强。

    此外，DLC还新增了两种变身形态、四把新武器以及一套全新的装备系统。对于已经通关本体的玩家来说，「狮驼岭」的难度进一步升级，需要更精准的操作和对战斗系统的深度理解。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20game%20scene%2C%20monkey%20warrior%20with%20staff%20facing%20giant%20demon%2C%20ancient%20Chinese%20temple%20ruins%2C%20dramatic%20moonlight%2C%20atmospheric%20fog%2C%20rich%20dark%20red%20and%20gold%20accents%2C%20cinematic%20game%20art%20style&width=800&height=450&seq=game-wukong&orientation=landscape',
    author: '编辑部',
    publishDate: '2026-07-29',
    viewCount: 52140,
    tags: ['游戏', '黑神话', 'DLC', '评测'],
  },
];

export const featuredArticles = articles.slice(0, 4);

export const latestArticles = articles;

export const testimonials = [
  {
    id: '1',
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20Asian%20man%2C%20clean%20white%20background%2C%20friendly%20smile%2C%20business%20casual%20attire%2C%20soft%20studio%20lighting%2C%20headshot%20photography&width=80&height=80&seq=avatar-1&orientation=squarish',
    content: '用了91天堂快三年了，资源更新速度真的是行业最快。画质清晰流畅，从来没有遇到过卡顿的问题。客服响应也很及时，强烈推荐！',
    rating: 5,
    date: '2026-07-28',
  },
  {
    id: '2',
    name: '王女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20Asian%20woman%2C%20clean%20white%20background%2C%20warm%20smile%2C%20modern%20casual%20style%2C%20soft%20studio%20lighting%2C%20headshot%20photography&width=80&height=80&seq=avatar-2&orientation=squarish',
    content: '作为一个追剧狂魔，91天堂的分类和推荐功能真的太好用了。想看什么类型直接点进去就有，而且每日更新的内容质量都很高，省去了到处找资源的时间。',
    rating: 5,
    date: '2026-07-25',
  },
  {
    id: '3',
    name: '李先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20Asian%20man%2C%20clean%20white%20background%2C%20confident%20expression%2C%20modern%20style%2C%20soft%20studio%20lighting%2C%20headshot%20photography&width=80&height=80&seq=avatar-3&orientation=squarish',
    content: '最满意的是资源的稳定性，用了这么久几乎没有遇到过链接失效的情况。会员权益也很实在，高清画质和去广告体验绝对值回票价。',
    rating: 5,
    date: '2026-07-20',
  },
  {
    id: '4',
    name: '赵同学',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20Asian%20young%20woman%2C%20clean%20white%20background%2C%20bright%20smile%2C%20casual%20style%2C%20soft%20studio%20lighting%2C%20headshot%20photography&width=80&height=80&seq=avatar-4&orientation=squarish',
    content: '动漫区的资源太全了，新番更新速度比日本本土还快！而且中文字幕翻译质量很高，还有双语字幕可选，日语学习党的福音！',
    rating: 5,
    date: '2026-07-18',
  },
];